import { ChevronDown } from 'lucide-react';
import React from 'react';

interface SelectedColorProps {
  selectedColor: string;
  placeholder: string;
  className: string;
  toggleDropdown?: () => void;
  disabled?: boolean;
}

export const SelectedColor: React.FC<SelectedColorProps> = ({
  selectedColor,
  placeholder,
  className,
  toggleDropdown,
  disabled = false
}) => {
  return (
    <div
      className={`flex h-[var(--erp-control-height)] cursor-pointer items-center justify-between rounded-md border border-gray-300 bg-background px-3 ${
        disabled ? 'cursor-not-allowed opacity-60' : ''
      } ${className}`}
      onClick={toggleDropdown}
    >
      <div className='flex w-full items-center gap-2'>
        <div className='flex w-full items-center'>
          <div className='h-6 w-full rounded-sm' style={{ backgroundColor: selectedColor || '#000000' }}>
            <span className='px-2 font-medium text-white drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)]'>
              {selectedColor || placeholder}
            </span>
          </div>
        </div>
      </div>
      <ChevronDown className='ml-1 h-4 w-4 text-gray-500' />
    </div>
  );
};
